import { clamp } from "utils/math/clamp";
import { CalculateZoomedViewBox } from "./types";

export const calculateZoomedViewBox: CalculateZoomedViewBox = ({
  zoomCenterX,
  zoomCenterY,
  factor,
  currentViewBox,
  baseViewBox,
  minZoomWidth,
}) => {
  const aspectRatio = baseViewBox.w / baseViewBox.h;

  const w = clamp({
    value: currentViewBox.w * factor,
    min: minZoomWidth,
    max: baseViewBox.w,
  });

  const h = w / aspectRatio;

  const sx = w / currentViewBox.w;
  const sy = h / currentViewBox.h;

  const x = clamp({
    value: zoomCenterX - (zoomCenterX - currentViewBox.x) * sx,
    min: baseViewBox.x,
    max: baseViewBox.w - w,
  });

  const y = clamp({
    value: zoomCenterY - (zoomCenterY - currentViewBox.y) * sy,
    min: baseViewBox.y,
    max: baseViewBox.h - h,
  });

  return { x, y, w, h };
};
